import { ReactNode, useMemo } from 'react';
import { Element } from 'hast';
import { parseRenderedTable } from '@/features/ai-agents/chat/MarkdownTableVisualization/helpers';
import {
  findCompareColumnIndex,
  findDefaultXAxisColumnIndex,
  findNumericColumnIndexes,
  findVariantColumnIndex,
  parseMarkdownTable,
} from '@/features/ai-agents/chat/MarkdownTableVisualization/utils';

export function useTableData(node: Element, children?: ReactNode) {
  const table = useMemo(() => parseMarkdownTable(node), [node]);
  const renderedTable = useMemo(() => parseRenderedTable(children), [children]);
  const numericColumnIndexes = useMemo(
    () => findNumericColumnIndexes(table),
    [table],
  );
  const variantColumnIndex = findVariantColumnIndex(table.headers);
  const isVariantReport = variantColumnIndex >= 0;
  const compareColumnIndex = findCompareColumnIndex(table.headers);
  const isCompareReport = compareColumnIndex >= 0;
  const excludedColumnIndexes = [variantColumnIndex, compareColumnIndex].filter(
    (columnIndex) => columnIndex >= 0,
  );
  const chartNumericColumnIndexes = numericColumnIndexes.filter(
    (columnIndex) => !excludedColumnIndexes.includes(columnIndex),
  );
  const defaultXColumnIndex = findDefaultXAxisColumnIndex(
    table.headers.length,
    chartNumericColumnIndexes,
    excludedColumnIndexes,
  );

  return {
    chartNumericColumnIndexes,
    compareColumnIndex,
    defaultXColumnIndex,
    isCompareReport,
    isVariantReport,
    numericColumnIndexes,
    renderedTable,
    table,
    variantColumnIndex,
  };
}
